"use strict";

exports.__esModule = true;
var _LayoutSelector = require("./LayoutSelector");
Object.keys(_LayoutSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutSelector[key]) return;
  exports[key] = _LayoutSelector[key];
});